/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKubernetesService = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M13 15.874V22h-2v-6.126a3.989 3.989 0 0 1-1.58-.817l-5.65 5.65-1.415-1.414 5.896-5.896A4.002 4.002 0 0 1 11 8.126V2h1.999v6.126a4.002 4.002 0 0 1 2.766 5.226l5.941 5.94-1.414 1.415-5.68-5.679a3.989 3.989 0 0 1-1.613.846zM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgKubernetesService as KubernetesService };
